<template>
  <div :class="computedClasses">
    <slot name="icon" />

    <slot />

    <TIcon
      v-if="hasTrigger"
      :icon="['far', 'chevron-down']"
      size="sm"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  hasTrigger?: boolean
  isActive?: boolean
  isHighlighted?: boolean
}>()

const attrs = useAttrs()

const hasClickHandler = computed(() => {
  return Boolean(attrs.onClick)
})

const computedClasses = computed(() => {
  return [
    'inline-flex items-center gap-x-2 rounded-full border px-3 py-1 text-sm font-semibold select-none transition-colors whitespace-nowrap lg:px-4 lg:py-2',
    {
      'border-gray-200': !props.isActive,
      'bg-primary-500 text-white border-primary-500': props.isActive,
      'cursor-pointer': hasClickHandler.value,
      'hover:bg-primary-600 hover:border-primary-600': hasClickHandler.value && props.isActive,
      'hover:bg-gray-100': hasClickHandler.value && !props.isActive && !props.isHighlighted,
      'bg-primary-50 border-secondary hover:bg-primary-100': hasClickHandler.value && !props.isActive && props.isHighlighted,
    },
  ]
})
</script>
